import { Injectable } from '@angular/core';
import { AuthorizationsObject, OAuthProfile } from '@dat/angular-auth';
import { LogOtelUser } from '@dat/log-beta';
import { snakeCase } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class IqTrackingOtelMapperService {
    userInfo(
        userProfile: OAuthProfile,
        authorization: AuthorizationsObject,
    ): LogOtelUser {
        const capabilities = this.capabilities(authorization);

        return {
            id: userProfile.oAuthId,
            oAuthProfile: userProfile,
            capabilities,
        };
    }

    capabilities(authObj: AuthorizationsObject): Record<string, boolean> {
        return (
            authObj?.permissions?.reduce(
                (
                    currentCapabilities: {
                        [key: string]: boolean;
                    },
                    permission: string,
                ): {
                    [key: string]: boolean;
                } => this.addCapability(permission, currentCapabilities),
                {},
            ) ?? {}
        );
    }

    addCapability(
        permission: string,
        currentCapabilities: {
            [key: string]: boolean;
        },
    ): {
        [key: string]: boolean;
    } {
        const capabilityKey: string = this.mapCapabilityKey(permission);

        return {
            ...currentCapabilities,
            [capabilityKey]: true,
        };
    }

    mapCapabilityKey(permission: string): string {
        return `cp_${snakeCase(permission)}`;
    }

    constructor() {}
}
